var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"timer",attrs:{"disabled":"","variant":"primary"}},[_vm._v(" 残り"+_vm._s(_vm.minutes > -1 ? ("" + _vm.minutes) : ' ')+"分"+_vm._s(_vm.seconds > -1 ? ("" + _vm.seconds) : ' ')+"秒 ")])}
var staticRenderFns = []

export { render, staticRenderFns }